/* RESPONSIBLE TEAM: team-data-foundations */
import Model, { attr } from '@ember-data/model';

export default class DataExportJobDefinition extends Model {
  @attr() declare schedule: 'hourly' | 'daily';
  @attr() declare state: 'paused' | 'active';
  @attr() declare verified: boolean;
  @attr() declare bulk: boolean;
  @attr() declare data_path: string;
  @attr() declare bucket_name: string;
  @attr() declare destination_type: 's3' | 'gcs' | 'azure_blob';
  @attr() declare azure_storage_account_name: string | null;
  @attr() declare skip_empty_files: boolean;
  @attr() declare format: 'JSON' | 'JSONL';
  @attr() declare include_attachments: boolean;
  @attr() declare data_api_version: string;
  @attr() declare use_date_folders: boolean;
  @attr() declare date_sorting_method: 'no_folders' | 'conversation_date' | 'export_date';
}
